// ----------------------------------------------------------------------------
// Component: Footer
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import { gsap } from "gsap";

// Scripts
import 'snippets/newsletter-form/newsletter-form';
import 'snippets/icon/icon';
import 'snippets/menu/menu';

// Styles
import './_footer.scss';

// Selectors
const FOOTER_SELECTOR  = '.footer';
const FOOTER_WAVE_PATH = '.footer__wave-animation-path';


// Function to create a GSAP animation timeline for the footer wave
// Reference: https://gsap.com/docs/v3/GSAP/Timeline
function footerWaveAnimation(path) {
    if( path != null ) {
        // Create the timeline for the entire animation
        const animationTimeline = gsap.timeline({ paused: true, repeat: -1, repeatDelay: 0 }); // Infinite loop (repeat: -1)

        // Define the path data for each keyframe
        const keyframes = [
            'M 0,400 C 0,400 0,200 0,200 C 124.42857142857144,203.35714285714286 248.8571428571429,206.71428571428572 382,227 C 515.1428571428571,247.28571428571428 657,284.5 766,273 C 875,261.5 951.1428571428571,201.28571428571428 1058,181 C 1164.857142857143,160.71428571428572 1302.4285714285716,180.35714285714286 1440,200 C 1440,200 1440,400 1440,400 Z',
            'M 0,400 C 0,400 0,200 0,200 C 125.57142857142858,191.17857142857144 251.14285714285717,182.35714285714286 369,193 C 486.85714285714283,203.64285714285714 596.9999999999999,233.75 719,254 C 841.0000000000001,274.25 974.8571428571429,284.64285714285717 1097,274 C 1219.142857142857,263.35714285714283 1329.5714285714284,231.67857142857142 1440,200 C 1440,200 1440,400 1440,400 Z',
            'M 0,400 C 0,400 0,200 0,200 C 90.46428571428572,198.14285714285714 180.92857142857144,196.28571428571428 310,183 C 439.07142857142856,169.71428571428572 606.7499999999999,145.00000000000003 729,149 C 851.2500000000001,152.99999999999997 928.0714285714287,185.71428571428572 1039,199 C 1149.9285714285713,212.28571428571428 1294.9642857142858,206.14285714285714 1440,200 C 1440,200 1440,400 1440,400 Z',
            'M 0,400 C 0,400 0,200 0,200 C 139.35714285714283,234.35714285714286 278.71428571428567,268.7142857142857 397,267 C 515.2857142857143,265.2857142857143 612.5,227.50000000000003 732,197 C 851.5,166.49999999999997 993.2857142857142,143.28571428571428 1115,145 C 1236.7142857142858,146.71428571428572 1338.357142857143,173.35714285714286 1440,200 C 1440,200 1440,400 1440,400 Z'
        ];

        // Create the keyframe animations
        keyframes.forEach((keyframe, index) => {
            animationTimeline.to(path, {
                duration: 2, // Adjust the duration as needed
                attr: { d: keyframe },
                ease: 'linear'
            });
        });

        return animationTimeline; // Return the timeline for external use
    }
}

// Function to initialize the animation
function initAnimation() {
    const laptopMedia = window.matchMedia('(min-width: 1024px)');
    const footer = document.querySelector(FOOTER_SELECTOR);
    const path = document.querySelector(FOOTER_WAVE_PATH);

    let animationTimeline;

    if ( footer != null && path != null && laptopMedia.matches ) {
        // Create the animation timeline
        animationTimeline = footerWaveAnimation(path);

        // Add an event listener to trigger the loop on hover
        footer.addEventListener('mouseenter', () => {
            clearTimeout(animationTimeoutId); // Clear any previous timeouts

            // Start the animation from the last recorded progress
            animationTimeline.play();
        });

        let animationTimeoutId;

        footer.addEventListener('mouseleave', () => {
            clearTimeout(animationTimeoutId); // Clear any previous timeouts

            const easeOutTime = 2; // Time to ease out in seconds

            // Calculate the new time for the animation timeline to ease out
            const newTime = animationTimeline.time() + easeOutTime;

            // Immediately ease out and stop 2 seconds after the mouse leaves
            animationTimeline
                .tweenTo(newTime, {
                    ease: 'cubic-bezier(.5, 0, .65, 1)',
                    duration: easeOutTime,
                })
                .eventCallback('onComplete', () => {
                    animationTimeline.pause(); // Pause the animation timeline after easing out
                });
        });
    }
}

function resetWavePath() {
    const path = document.querySelector(FOOTER_WAVE_PATH);

    // Set the flag to true to prevent further execution
    if( path != null ) {
        path.setAttribute('d', 'M 0,400 C 0,400 0,200 0,200 C 139.35714285714283,234.35714285714286 278.71428571428567,268.7142857142857 397,267 C 515.2857142857143,265.2857142857143 612.5,227.50000000000003 732,197 C 851.5,166.49999999999997 993.2857142857142,143.28571428571428 1115,145 C 1236.7142857142858,146.71428571428572 1338.357142857143,173.35714285714286 1440,200 C 1440,200 1440,400 1440,400 Z');
    }
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', function() {
    initAnimation();
});

let resizeTimeout;
window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);

    resizeTimeout = setTimeout(() => {
        resetWavePath();
        initAnimation();
    }, 500); // Adjust the delay (in milliseconds) as needed

});
